import { render } from "./XdList.vue?vue&type=template&id=5bc76c40&scoped=true"
import script from "./XdList.vue?vue&type=script&lang=js"
export * from "./XdList.vue?vue&type=script&lang=js"

import "./XdList.vue?vue&type=style&index=0&id=5bc76c40&lang=less&scoped=true"

import exportComponent from "C:\\Users\\徐永哲\\Desktop\\银商北分远程办公系统\\wx-wl_full_II\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bc76c40"]])

export default __exports__